<template>
  <v-app style="font-family: 'Montserrat', 'sans-serif' !important">
    <template v-if="$store.getters.user">
      <Navbar />
      
      <v-content
        class="ma-0 pa-0 grey lighten-4 mx-4 mb-4"
        style="background-image: url('/home.jpg')"
      >
        <v-content class="grey lighten-4 mx-4 mb-4 overflow-y-auto">
          <router-view></router-view>
          <v-snackbar v-model="showsnack" :timeout="11000">
            {{ snack }}
            <v-btn color="blue" text @click="$store.dispatch('showSnack', '')"
              >Cerrar</v-btn
            >
          </v-snackbar>
        </v-content>
      </v-content>
      
          <Footer />
    </template>
    <template v-if="!$store.getters.user">
      <v-content
        class="ma-0 pa-0 grey lighten-4 mx-4 mb-4 overflow-y-auto"
        style="background-image: url('img/login.jpg')"
      >
        <router-view></router-view>
      </v-content>
      
    </template>
  </v-app>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";

export default {
  components: { Navbar, Footer },
  data: () => ({}),
  computed: {
    snack() {
      return this.$store.getters.snack;
    },
    showsnack() {
      return this.$store.getters.snack == "" ? false : true;
    }
  }
};
</script>
